import React from "react";
import { CommonProps } from "fds/src/helpers/props";
import classNames from "classnames";
import "./index.scss";

export interface IProps extends CommonProps {
  width?: string | number | undefined;
  height?: string | number | undefined;
}
const WrapIcon: React.FC<IProps> = ({ classes, width, height }) => {
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      className={classNames(classes, "")}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.5"
        y="2.5"
        width="6"
        height="6"
        rx="1"
        fill="#B5BBC2"
        stroke="#B5BBC2"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="2.5"
        y="11.5"
        width="6"
        height="6"
        rx="1"
        fill="#B5BBC2"
        stroke="#B5BBC2"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="11.5"
        y="2.5"
        width="6"
        height="6"
        rx="1"
        fill="#B5BBC2"
        stroke="#B5BBC2"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.5 12V17"
        stroke="#B5BBC2"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 14.5L12 14.5"
        stroke="#B5BBC2"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default WrapIcon;
